import { useState } from "react";
import { PawPrint, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const AdminLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email: email.trim(), password });
      onSuccess(data);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ivory px-4" data-testid="admin-login">
      <div className="w-full max-w-sm rounded-[28px] bg-white/70 p-8 shadow-[0_24px_60px_-30px_rgba(42,37,30,0.35)] sm:p-10">
        <div className="flex flex-col items-center">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#A8BFCE]/40">
            <PawPrint className="h-5 w-5 text-[#6E8CA3]" fill="#6E8CA3" strokeWidth={0} />
          </span>
          <h1 className="mt-4 font-serif text-2xl font-medium tracking-tight text-ink">
            Freebies Admin
          </h1>
          <p className="mt-1 text-[11px] font-medium uppercase tracking-[0.24em] text-ink/50">
            My Dachshund Days
          </p>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label htmlFor="admin-email" className="mb-1.5 block text-[11px] font-semibold uppercase tracking-[0.18em] text-ink/60">
              Email
            </label>
            <input
              id="admin-email"
              data-testid="admin-email-input"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-12 w-full rounded-full border border-ink/15 bg-white px-5 text-[15px] text-ink focus:border-ink/40 focus:outline-none"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-1.5 block text-[11px] font-semibold uppercase tracking-[0.18em] text-ink/60">
              Password
            </label>
            <input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-12 w-full rounded-full border border-ink/15 bg-white px-5 text-[15px] text-ink focus:border-ink/40 focus:outline-none"
            />
          </div>
          {error && (
            <p role="alert" data-testid="admin-login-error" className="text-[13px] font-medium text-[#A03D2A]">
              {error}
            </p>
          )}
          <button
            type="submit"
            data-testid="admin-login-button"
            disabled={loading}
            className="flex h-[52px] w-full items-center justify-center gap-2 rounded-full bg-[#6E8CA3] text-[13px] font-semibold uppercase tracking-[0.18em] text-ivory transition-transform duration-300 hover:scale-[1.02] active:scale-[0.98] disabled:opacity-70"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Log In
          </button>
        </form>
      </div>
    </div>
  );
};
